import {Component, OnInit, ViewChild} from '@angular/core';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ProjectControlItemService,
  ProjectService
} from '../../_services';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {ActionPlan} from "../../_models/actionPlan";
import {FormBuilder, Validators} from "@angular/forms";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DictionaryService } from "../../_services/dictionary.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';
import {InspectionResultsPopupComponent} from "../inspectionResultsPopup/inspectionResultsPopup.component";
import {DialogService} from "primeng/dynamicdialog";
import {CveService} from "../../_services/cve.service";
import {forkJoin} from "rxjs";

@Component({
    standalone: false,
  selector: "globalProjectControlItems-component",
  templateUrl: './globalProjectControlItems.component.html',
  styleUrls: ['./globalProjectControlItems.component.scss'],
})

export class GlobalProjectControlItemsComponent implements OnInit {
  projectControlItems: any[] = [];
  currentUser: User;
  tenantName: string;
  lowMediumHigh = {0: 'Low', 1: 'Medium', 2: 'High'};
  cols = [
    {header: 'Project', field: 'projectName'},
    {header: 'Category', field: 'controlItem.category'},
    {header: 'Control ID', field: 'controlItem.complianceAreaControlId'},
    {header: 'Implementation Control Statement', field: 'solutionDescriptionText'},
    {header: 'Inherited Controls', field: 'inheritedControls'},
  ]

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public config: IndexConfigService,
    public authenticationService: AuthenticationService,
    public projectControlItemService: ProjectControlItemService,
    public dictionaryService: DictionaryService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public clientProfileService: ClientProfileService,
    private constants: AppTextResourcesService) {

  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    forkJoin([
      this.projectControlItemService.getAll(),
      this.dictionaryService.get(['Service'])
    ]).subscribe(d => {
      this.projectControlItems = d[0];
      this.projectControlItems.forEach(c => {
        c.solutionDescriptionText = (c.solutionDescription || '').replace(/<\/?[^>]+(>|$)/g, " ");
        c.inheritedControls = c.sharedResponsibilities.map(r => (d[1].find(s => s.itemId == r.dictionaryItemId) || {}).name).filter(r => r).join(', ');
      })
    });
  }
}
